import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Menu from '../../../../components/Menu';
import PremiumHemSubscription from '../../../../components/PremiumHemSubscription';
import HasRole from '../../../../components/HasRole';

import * as constants from '../../../Authorization/constants';

import PremiumFeatureButton from './premiumFeatureButton';
import '../../styles.css';

const PremiumMenuItem = ({
  onPremiumFeatureClick,
  menuTitle,
  onClick,
}) => (
  <HasRole anyOf={[constants.ADMIN_ROLE, constants.PUBLISHING_ROLE]}>
    <PremiumHemSubscription>
      <Menu.Item as="li" styleName="editor-menu-item enabled" data-cy="Premium-Hem-Menu-Link-Photos-Videos" link onClick={onClick}>
        <FormattedMessage {...menuTitle} />
      </Menu.Item>
    </PremiumHemSubscription>
    <PremiumHemSubscription inactive>
      <Menu.Item as="li" styleName="editor-menu-item" link>
        <FormattedMessage {...menuTitle} />
        <PremiumFeatureButton
          styles="premium-feature-button"
          onClick={onPremiumFeatureClick}
        />
      </Menu.Item>
    </PremiumHemSubscription>
  </HasRole>
);

PremiumMenuItem.propTypes = {
  onPremiumFeatureClick: PropTypes.func.isRequired,
  menuTitle: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default PremiumMenuItem;
